export default __webpack_public_path__ + "static/media/termsAndConditions_root_background.8803c7f5.jpg";